import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default function initComandsSwiper() {
  const swiper = new Swiper(".comands__slider", {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    allowTouchMove: false,

    // Navigation arrows
    navigation: {
      nextEl: ".comands-button-next",
      prevEl: ".comands-button-prev",
    },

    // 👇 Настройки под разные разрешения
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.6,
      },
      1440: {
        slidesPerView: 3.3,
      },
    },
  });
}
